import React, { FC } from 'react';

import { LogoProps } from '../types';

import styles from './Logo.module.scss';

const Logo: FC<LogoProps> = ({
  width= '136',
  height= '31',
  fill='none',
  viewBox='0 0 136 31',
}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg"
         width={width}
         height={height}
         fill={fill}
         viewBox={viewBox}
         role="img">
      <path className={styles.textClassName}
            d="M5.436 24.987V10.708H0V7.154h14.912v3.554H9.5v14.276H5.436v.003ZM18.041 24.987V7.154h12.868v3.53h-8.83v3.475h7.01v3.422h-7.01v3.851h9.069v3.555H18.041ZM34.69 24.987V7.154h2.5l9.078 10.697V7.154h3.982v17.833h-2.312l-9.265-10.911v10.91H34.69ZM53.835 24.987V7.154h2.5l9.078 10.697V7.154h3.983v17.833h-2.313l-9.265-10.911v10.91h-3.983ZM73.59 24.987V7.154h4.037v17.833h-4.038ZM80.19 22.473l2.594-2.808c.462.498 1.083.988 1.857 1.47.774.481 1.679.723 2.713.723.41 0 .81-.077 1.202-.227a2.45 2.45 0 0 0 .976-.666c.257-.294.388-.646.388-1.056 0-.66-.32-1.177-.963-1.55-.643-.374-1.658-.732-3.047-1.071-1.355-.34-2.477-.936-3.368-1.793-.89-.856-1.336-1.96-1.336-3.315 0-.998.241-1.912.721-2.741.48-.83 1.203-1.496 2.166-2.007.964-.508 2.175-.761 3.637-.761 1.211 0 2.233.156 3.062.468.829.312 1.493.654 1.991 1.03.499.374.848.68 1.043.909l-2.324 2.566a16.329 16.329 0 0 0-1.551-1.03c-.642-.383-1.401-.576-2.273-.576-.572 0-1.101.165-1.59.496-.49.33-.735.728-.735 1.19 0 .605.322 1.095.964 1.471.642.373 1.523.685 2.646.936.872.214 1.716.535 2.526.964a5.414 5.414 0 0 1 1.992 1.792c.517.768.774 1.765.774 2.995 0 1.07-.303 2.021-.909 2.86-.606.838-1.425 1.495-2.46 1.979-1.033.48-2.192.722-3.474.722-1.178 0-2.218-.144-3.13-.429-.908-.284-1.703-.654-2.379-1.11a9.663 9.663 0 0 1-1.713-1.431ZM97.274 24.987V7.154h4.037v17.833h-4.037Z" />
      <path className={styles.circleClassName}
            d="M122.2 29c7.18 0 13-5.82 13-13s-5.82-13-13-13-13 5.82-13 13 5.82 13 13 13Z" />
    </svg>
  );
};

export default Logo;
